import { lazy, Suspense, type ReactNode } from 'react';
import { useLook } from '@/app/theme';

/*
 * THE LAYER ITSELF IS ITS OWN CHUNK. The wallpapers' fields and the moving lights are a stylesheet
 * and a few layers; they load the first time somebody chooses one, never with the sign-in screen
 * (lumen-fe CLAUDE.md, rule 3). The stylesheet comes in with that chunk, after `app.css`, so its
 * unlayered rules cannot disturb the cascade's layer order.
 */
const WallpaperLayer = lazy(() => import('./WallpaperLayer').then((m) => ({ default: m.WallpaperLayer })));

/**
 * THE BACKGROUND LAYER (prototype v2's Wallpaper and Motion, 2026-11-02). Fixed, full viewport,
 * behind the shell; the Shell mounts it as its first and back-most child.
 *
 * Drawn only where it can be seen: behind a see-through material (Glass, Granite), and not for the
 * console's own glow, which the Shell has drawn since 2026-10-26 (`.lm-glow`). Solid and Charcoal
 * are opaque, so nothing is loaded for them at all.
 */
export function Wallpaper(): ReactNode {
  const shown = useLook((s) => (s.look.material === 'glass' || s.look.material === 'granite') && (s.look.background !== 'glow' || s.look.movingLight !== 'none' || s.look.photo));
  if (!shown) return null;
  return (
    <Suspense fallback={null}>
      <WallpaperLayer />
    </Suspense>
  );
}
